export default {spreads:{RegistryItemSummary:{}}}